
export class SeasonedLoanFeesWrapper {
  sellerNumber?: string;
  contractNumber?: string;
  seasonedLoanFeeAmount?: string;
  username: string;
}
